import { forwardRef, ForwardedRef } from 'react'
import { Color } from '../../constants'
import styles from './Button.module.scss'

const Button = forwardRef(
  (
    {
      children,
      className = '',
      textColor = Color.Green,
      backgroundColor = Color.White,
      onClick,
      type = 'button',
      styles: userStyles = {},
    }: {
      children: React.ReactNode
      className?: string
      textColor?: string
      backgroundColor?: string
      onClick?: () => void
      type?: 'button' | 'submit' | 'reset'
      styles?: React.CSSProperties
    },
    ref: ForwardedRef<HTMLButtonElement>
  ) => {
    return (
      <button
        ref={ref}
        tabIndex={0}
        type={type}
        style={
          {
            '--c-text': textColor,
            '--c-background': backgroundColor,
            ...userStyles,
          } as React.CSSProperties
        }
        className={`${styles.button} ${className}`}
        onClick={onClick}
      >
        {children}
      </button>
    )
  }
)
export default Button
